export default "__VITE_ASSET__f6d3084f__"